import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
import VeltCommentDialogSuggestionMenuContentItemWireframe from './VeltCommentDialogSuggestionMenuContentItemWireframe/VeltCommentDialogSuggestionMenuContentItemWireframe';
var VeltCommentDialogSuggestionMenuContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-menu-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogSuggestionMenuContentWireframe.Item = VeltCommentDialogSuggestionMenuContentItemWireframe;
export default VeltCommentDialogSuggestionMenuContentWireframe;
